module.exports = __webpack_public_path__ + "img/icon-school.a46f7585.png";